import { trackWebVital } from './utils/analytics';

/**
 * Report Web Vitals to Google Analytics 4
 * @param {Function} onPerfEntry - Optional callback function for custom handling
 */
const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS((metric) => {
        trackWebVital(metric);
        onPerfEntry(metric);
      });
      getFID((metric) => {
        trackWebVital(metric);
        onPerfEntry(metric);
      });
      getFCP((metric) => {
        trackWebVital(metric);
        onPerfEntry(metric);
      });
      getLCP((metric) => {
        trackWebVital(metric);
        onPerfEntry(metric);
      });
      getTTFB((metric) => {
        trackWebVital(metric);
        onPerfEntry(metric);
      });
    });
  } else {
    // If no callback provided, still track to GA4
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(trackWebVital);
      getFID(trackWebVital);
      getFCP(trackWebVital);
      getLCP(trackWebVital);
      getTTFB(trackWebVital);
    });
  }
};

export default reportWebVitals;
